var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var TagDotIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 40,
    glyphHeight: 50
  }), React.createElement("path", {
    d: "M34.1846 0C37.6685 0.000200421 40.4998 2.92125 40.5 6.51562V43.4727C40.5 45.9161 39.195 48.1322 37.0898 49.2617C36.1742 49.7504 35.1739 49.9999 34.1846 50L34.1943 49.9893C32.9209 49.9892 31.6473 49.5875 30.5527 48.7949L21.7207 42.3652C20.9944 41.8333 20.0153 41.8332 19.2891 42.3652L10.458 48.7949C8.52118 50.2067 6.01538 50.3803 3.91016 49.2617C1.80501 48.1322 0.5 45.9161 0.5 43.4727V6.51562C0.500235 2.92125 3.33153 0.000201224 6.81543 0H34.1846ZM6.82617 4.34375C5.66849 4.34383 4.72094 5.32126 4.7207 6.51562V43.4727C4.7207 44.2979 5.14184 45.0261 5.85742 45.4062C6.57321 45.7864 7.38448 45.7318 8.03711 45.2539L16.8682 38.8252C17.9629 38.0324 19.2371 37.6299 20.5107 37.6299C21.7843 37.6299 23.0577 38.0325 24.1523 38.8252L32.9844 45.2539C33.637 45.7317 34.4578 45.7863 35.1631 45.4062C35.8789 45.0261 36.2998 44.3089 36.2998 43.4727V6.51562C36.2996 5.32122 35.3521 4.34375 34.1943 4.34375H6.82617ZM20.5 10C22.8263 10 24.7109 11.79 24.7109 14C24.7109 16.21 22.8263 18 20.5 18C18.1737 18 16.2891 16.21 16.2891 14C16.2891 11.79 18.1737 10 20.5 10Z",
    fill: "black"
  }));
};
export var TagDotIconGlyph = function (props) {
  return React.createElement(TagDotIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};